import React, { FC } from 'react';
import { CommonProps, components, InputProps } from 'react-select';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Input: FC<InputProps & { name: string; selectProps: CommonProps<any>['selectProps'] }> = (props) => (
  <components.Input {...props} {...{ name: props.selectProps.name }} />
);
